<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>سجل المكالمات</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                            هنا يتم عرض جميع المكالمات الصادرة للمستخدمين
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                                <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <label>الفرع</label>
                                <select @change='GetUsers($event)' class="form-control"  v-model="branche">
                                  <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <vue-element-loading size='64' :active='isLoadingUsers'  spinner='bar-fade-scale' color='#A4A4A4'/>
                                <label>المستخدم</label>
                                <select class="form-control"  v-model="user_id">
                                  <option v-for="item in users" v-bind:key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <tbDate :today='today' :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <tbDate :today='today' :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6' style="padding :25px">
                                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                  <b> عرض </b>
                                </button>
                              </div>
                              <div style="padding-top:30px">
                              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                  <thead>
                                    <tr>
                                      <th style='padding:2px;text-align: center'>م</th>
                                      <th style='padding:2px;text-align: center'>السجل</th>
                                      <th style='padding:2px;text-align: center'>الاسم</th>
                                      <th style='padding:2px;text-align: center'>التاريخ</th>
                                      <th style='padding:2px;text-align: center'>الوقت</th>
                                      <th style='padding:2px;text-align: center'>الغرض</th>
                                      <th style='padding:2px;text-align: center'>الحالة</th>
                                      <th style='padding:2px;text-align: center'>الاجراء</th>
                                      <th style='padding:2px;text-align: center'>تأجيل</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                      <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>

                                         <td align='center'>{{index +1 }}</td>
                                         <td align='center'>{{record.rec_id}}</td>
                                         <td align='center'>{{record.name}}</td>
                                         <td align='center'>{{record.date}}</td>
                                        <td align='center'>{{record.time}}</td>
                                        <td align='center'>{{record.call_type}}</td>
                                        <td align='center'>{{record.call_status}}</td>
                                        <td align='center'>{{record.call_action}}</td>
                                        <td align='center'>{{record.call_delay}}</td>
                                      </tr>
                                  </tbody>
                              </table>
                            </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<style>
.disabled {
    pointer-events: none;
    cursor: default;
    color: gray;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  name: 'usercallLog',
  components: {
    tbDate
  },
  data () {
    return {
      today: true,
      fromTitle: 'من تاريخ',
      toTitle: 'الى تاريخ',
      from_date: '',
      to_date: '',
      validationErrors: '',
      records: {},
      isLoadingData: false,
      isLoadingUsers: false,
      disabled: true,
      branches: [],
      branche: '',
      users: [],
      user_id: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
  },
  methods: {
    GetUsers () {
      this.isLoadingUsers = true
      axios.post(this.$apiURL + 'get-caller-users', {
        token: localStorage.getItem('token'),
        branche_id: this.branche
      })
        .then(({ data }) => {
          this.users = data
          this.isLoadingUsers = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingUsers = false
        })
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-all-user-call-log', {
        token: localStorage.getItem('token'),
        user_id: this.user_id,
        date_from: this.from_date,
        date_to: this.to_date
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/AllUsersCallLog.vue